module.exports = __webpack_public_path__ + "b96ff29b2c0a9ca17334f0e23a35c5e8.jpg";